/**
 *  default prefix "CARD_NUMBER_"
 */

export const AT_STATE_UPDATE = 'CARD_NUMBER_STATE_UPDATE';
export const AT_STATUS_CHANGE = 'CARD_NUMBER_STATUS_CHANGE';
